export enum BookingStatus {
  DRAFT = 'DRAFT', // first status after booking is created and waiting for payment
  FLOATING = 'FLOATING', // if open or confirmed booking needs bigger changes and needs to be not-blocking, can be switchted to FLOATING
  OPEN = 'OPEN', // after payment went through
  CONFIRMED = 'CONFIRMED', // after the booking is confirmed
  HANDED_OVER = 'HANDED_OVER', // after the booking is handed over to the driver
  CAR_RETURNED = 'CAR_RETURNED',
  CANCELED = 'CANCELED',
  FINALIZED = 'FINALIZED',
}
